import { useQuery } from '@apollo/client';
import { GET_USER_DATA } from '@shared/Authentication';
import { isColombia } from '@shared/utils/region-utils';
import Router from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

export const RightSide = styled.div<{ isMobile }>`
  display: flex;
  gap: ${(props) => (props.isMobile ? 0 : '9px')};
`;

type Link = {
  key: string;
  text: string;
  href: string;
  rel?: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
};

export const useOptionsNavbar = () => {
  const [rolUserLogged, setRolUserLogged] = useState();
  const [idUserLogged, setIdUserLogged] = useState(null);

  useQuery(GET_USER_DATA, {
    onCompleted: (dataAuthUser) => {
      setIdUserLogged(dataAuthUser?.getAuthenticatedUser?.id);
      setRolUserLogged(dataAuthUser?.getAuthenticatedUser?.role);
    },
  });

  const isLandlordLogged = rolUserLogged === 'LANDLORD';

  const getRefererForLandlord = () =>
    isColombia()
      ? `https://arrienda.aptuno.com/propietarios/refiere-gana/index.html?propietario=${idUserLogged}`
      : `https://renta.aptuno.mx/propietarios/refiere-gana/index.html?propietario=${idUserLogged}`;

  const getRefererForTenantOrAgent = () =>
    isColombia()
      ? 'https://arrienda.aptuno.com/agentes-4/agentes.html'
      : 'https://renta.aptuno.mx/asesores-04/asesores.html ';

  const defaultMenuItems: Link[] = [
    {
      key: 'buscar_inmueble',
      text: 'Buscar Inmueble',
      href: '/inmuebles-arriendo',
    },
    {
      key: 'calculadora_arrendamiento',
      text: isColombia() ? 'Calculadora de Arriendo' : 'Calculadora de Renta',
      href: isColombia()
        ? '/calculadora-de-arrendamiento'
        : '/calculadora-de-renta',
    },
    {
      key: isLandlordLogged ? 'refiere_gana' : 'gana_dinero_con_aptuno',
      text: isLandlordLogged ? 'Refiere y gana' : 'Gana dinero con Aptuno',
      href: isLandlordLogged
        ? getRefererForLandlord()
        : getRefererForTenantOrAgent(),
      target: '_blank',
      rel: 'nofollow',
    },
    {
      key: 'ayuda',
      text: 'Ayuda',
      href: '/ayuda',
    },
  ];

  const [menuItems, setMenuItems] = useState<Link[]>(defaultMenuItems);

  useEffect(() => {
    if (!!idUserLogged)
      setMenuItems([
        defaultMenuItems[0],
        {
          href: `/recomendaciones-para-ti?utm_source=navbar&utm_medium=web&utm_campaign=rec_product`,
          key: 'recomendaciones_para_ti',
          text: '🔥 Inmuebles para ti',
        },
        ...defaultMenuItems.slice(1),
      ]);
  }, [idUserLogged]);

  return menuItems;
};

export const mainlinkOptions: Array<Link> = [
  {
    key: 'publicar_inmueble',
    text: 'Publicar Inmueble',
    href: isColombia()
      ? '/publicar-inmueble-en-arriendo'
      : '/anunciar-casa-o-departamento-en-renta',
  },
];

type MenuItem = {
  key: string;
  name: string;
  icon: string;
  onClick: () => void;
};

export const menuItems: Array<MenuItem> = [
  {
    key: 'mi_cuenta',
    name: 'Mi cuenta',
    icon: 'aptunohome',
    onClick: () => Router.push('/perfil'),
  },
  {
    key: 'mis_publicaciones',
    name: 'Mis publicaciones',
    icon: 'listunordered',
    onClick: () => Router.push('/listing-publications'),
  },
  {
    key: 'mis_pagos',
    name: 'Mis pagos',
    icon: 'currency',
    onClick: () => Router.push('/pagos/pendientes'),
  },
  {
    key: 'mis_contratos_de_arrendamiento',
    name: 'Mis contratos',
    icon: 'aptunohome',
    onClick: () => Router.push('/agreements'),
  },
  {
    key: 'mis_agendamientos',
    name: 'Mis agendamientos',
    icon: 'calendar',
    onClick: () => Router.push('/perfil/visitas-pendientes'),
  },
  {
    key: 'soy_captador',
    name: 'Soy Broker',
    icon: 'user',
    onClick: () => Router.push('/agente-captador'),
  },
];

const doLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user-data');
  window.location.href = '/';
};

export const loginItem: MenuItem = {
  key: 'cerrar_sesion',
  name: 'Cerrar sesión',
  icon: 'closeAlt',
  onClick: () => doLogout(),
};
